import { Handle, Position } from '@xyflow/react'

export function BlendByBoolNode({ data, selected }) {
  const active = !!(data.defaultValue)
  const hasVar = !!data.boolVariable

  const trueBlendTime  = data.trueBlendTime  ?? 0.1
  const falseBlendTime = data.falseBlendTime ?? 0.1

  return (
    <div style={{
      background: selected ? '#1a2a1a' : '#121a12',
      border: `2px solid ${selected ? '#60c060' : '#305030'}`,
      borderRadius: 6,
      padding: '10px 14px',
      minWidth: 190,
      color: '#ddd',
      fontFamily: 'var(--m-font)',
      fontSize: 12,
    }}>
      {/* Title */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 10 }}>
        <span style={{ fontSize: 14 }}>🔀</span>
        <span style={{ color: '#80e880', fontWeight: 'bold', fontSize: 11 }}>BLEND BY BOOL</span>
      </div>

      {/* True Pose (B) — plays when true */}
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 6, position: 'relative' }}>
        <Handle type="target" position={Position.Left} id="b"
          style={{ background: '#e07040', width: 10, height: 10, top: '50%', transform: 'translateY(-50%)' }} />
        <span style={{ marginLeft: 14, color: active ? '#e07040' : '#555', fontSize: 11 }}>True Pose</span>
      </div>

      {/* False Pose (A) — plays when false */}
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 10, position: 'relative' }}>
        <Handle type="target" position={Position.Left} id="a"
          style={{ background: '#e07040', width: 10, height: 10, top: '50%', transform: 'translateY(-50%)' }} />
        <span style={{ marginLeft: 14, color: active ? '#555' : '#e07040', fontSize: 11 }}>False Pose</span>
      </div>

      {/* True Blend Time */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
        <span style={{ color: '#80e880', fontSize: 10, flex: 1 }}>True Blend Time</span>
        <input
          type="number"
          min={0} max={5} step={0.05}
          value={trueBlendTime}
          onChange={e => data.onChange?.('trueBlendTime', parseFloat(e.target.value) || 0)}
          onMouseDown={e => e.stopPropagation()}
          style={{
            width: 52, background: '#0a180a', border: '1px solid #1a401a',
            color: '#80e880', padding: '2px 4px', borderRadius: 3,
            fontSize: 10, fontFamily: 'var(--m-mono)', outline: 'none', textAlign: 'right',
          }}
        />
      </div>

      {/* False Blend Time */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 8 }}>
        <span style={{ color: '#80e880', fontSize: 10, flex: 1 }}>False Blend Time</span>
        <input
          type="number"
          min={0} max={5} step={0.05}
          value={falseBlendTime}
          onChange={e => data.onChange?.('falseBlendTime', parseFloat(e.target.value) || 0)}
          onMouseDown={e => e.stopPropagation()}
          style={{
            width: 52, background: '#0a180a', border: '1px solid #1a401a',
            color: '#80e880', padding: '2px 4px', borderRadius: 3,
            fontSize: 10, fontFamily: 'var(--m-mono)', outline: 'none', textAlign: 'right',
          }}
        />
      </div>

      {/* Bool input + fallback toggle */}
      <div style={{ marginBottom: 4 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4, position: 'relative' }}>
          <Handle type="target" position={Position.Left} id="bool-in"
            style={{ background: '#80e880', width: 8, height: 8, top: '50%', transform: 'translateY(-50%)' }} />
          <span style={{ marginLeft: 12, color: '#80e880', fontSize: 10 }}>
            Active Value{hasVar ? ' (var)' : ''}
          </span>
          <input
            type="checkbox"
            checked={active}
            onChange={e => data.onChange?.('defaultValue', e.target.checked)}
            onMouseDown={e => e.stopPropagation()}
            style={{ marginLeft: 'auto', accentColor: '#80e880', cursor: 'pointer', width: 14, height: 14 }}
          />
        </div>
      </div>

      {/* Optional variable override */}
      <div style={{ marginBottom: 4 }}>
        <div style={{ color: '#284028', fontSize: 9, marginBottom: 2 }}>Variable (optional)</div>
        <input
          type="text"
          value={data.boolVariable ?? ''}
          onChange={e => data.onChange?.('boolVariable', e.target.value || undefined)}
          onMouseDown={e => e.stopPropagation()}
          placeholder="none"
          style={{
            width: '100%', boxSizing: 'border-box',
            background: '#0a180a', border: '1px solid #1a301a',
            color: hasVar ? '#80e880' : '#555', padding: '3px 6px',
            borderRadius: 3, fontSize: 10,
            fontFamily: 'var(--m-mono)', outline: 'none',
          }}
        />
      </div>

      {/* Output */}
      <Handle type="source" position={Position.Right} id="anim"
        style={{ background: '#e07040', width: 10, height: 10 }} />
    </div>
  )
}
